<template>
  <div v-if="storeId">
    <order-cache-new v-if="isAmendNNew"></order-cache-new>
    <order-cache v-else></order-cache>
  </div>
</template>

<script>
  import orderCache from '@/pagesCache/order/index';
  import orderCacheNew from '@/pagesCache/order/orderNew';
  import {mapState} from 'vuex';
  const errorFn = function(e){
    window.errorList = window.errorList || [];
    window.errorList.push(e.filename+'\nLine'+e.lineno+'\n'+e.message);
    console.log(e)
  };
  export default {
    layout: 'sidebar',
    name: 'order',
    created () {
      window.addEventListener('error',errorFn);
    },
    activated () {
      if (!this.storeId) {
        this.$router.push({name: 'customer'})
      }
    },
    computed: {
      ...mapState({
        isAmend: state => state.booking.user.orderAmend.isAmend,
        newAmend: state => state.booking.user.newAmend, 
      }),
      storeId () {
        return this.$store.state.booking.user.storeId
      },
      isAmendNNew() {
        return this.isAmend && this.newAmend;
      },
    },
    data(){
      return {
      }
    },
    methods:{
    },
    components: {
      orderCache,
      orderCacheNew,
    }
  }
</script>




// WEBPACK FOOTER //
// pages/order.vue